function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import CustomerCareLocaleKeys from '../../../../../locales/keys';
import { ContractsSearchCriteriaSelector, ContractsSearchResultsViewModelSelector, IsFetchingContractsSelector } from '../../../../../reducers/selectors/contracts.list.selectors';
import { IsFetchingActiveContractSelector } from '../../../../../reducers/selectors/offering.order.selectors';
import { resetSearchCriteria, setSearchCriteriaAndSearchContracts } from '../../../../../reducers/actions/contracts.list.actions';
var mapStateToTarget = function mapStateToTarget(store) {
  return {
    contracts: ContractsSearchResultsViewModelSelector(store),
    isFetchingActiveContract: IsFetchingActiveContractSelector(store),
    isFetchingContracts: IsFetchingContractsSelector(store),
    searchCriteria: ContractsSearchCriteriaSelector(store)
  };
};
var controllerActions = {
  resetSearchCriteria: resetSearchCriteria,
  setSearchCriteriaAndSearchContracts: setSearchCriteriaAndSearchContracts
};
var SelectContractPopupController = /*#__PURE__*/function () {
  function SelectContractPopupController($ngRedux) {
    _classCallCheck(this, SelectContractPopupController);
    this.$ngRedux = $ngRedux;
    this.disconnectRedux = null;
  }
  return _createClass(SelectContractPopupController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.customerCareLocaleKeys = CustomerCareLocaleKeys;
      this.coreLocaleKeys = CoreLocaleKeys;
      this.selectedContractId = this.contractId || null;
      this.formErrors = [];
      this.pageNumber = 1;
      this.searchText = '';
      this.handleClose = function () {
        _this.onClose()();
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      if (!this.state.isFetchingContracts) {
        this.actions.resetSearchCriteria();
        this.searchCriteria = this.cloneContractSearchCriteria();
        this.actions.setSearchCriteriaAndSearchContracts(this.searchCriteria);
      }
      this.search = function () {
        _this.searchCriteria.PageNumber = 1;
        _this.searchCriteria.SearchFor = _this.searchText;
        _this.actions.setSearchCriteriaAndSearchContracts(_this.searchCriteria);
      };
      this.onUpdateSelectedContract = function () {
        _this.formErrors = null;
        _this.onSuccess()(_this.state.contracts.find(function (x) {
          return x.Id === _this.selectedContractId;
        }));
      };
      this.pageSelected = function (pageNumber) {
        _this.pageNumber = pageNumber;
        _this.onSubmitSearch();
      };
    }
  }, {
    key: "cloneContractSearchCriteria",
    value: function cloneContractSearchCriteria() {
      var searchCriteria = this.state.searchCriteria;
      searchCriteria.CurrencyCode = this.currencyCode;
      searchCriteria.SubtenantIds = this.subTenants && !!this.subTenants.Id ? [parseInt(this.subTenants.Id.Value, 10)] : this.subTenants && !this.subTenants.Id ? this.subTenants.map(function (subTenant) {
        return parseInt(subTenant.Value, 10);
      }) : [];
      return searchCriteria;
    }
  }, {
    key: "selectContract",
    value: function selectContract(contract) {
      this.selectedContractId = contract.Id;
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  template: require('./select.contract.popup.html'),
  controller: SelectContractPopupController,
  bindings: {
    contractId: '<',
    currencyCode: '<?',
    onClose: '&',
    onSuccess: '&',
    subTenants: '<?'
  }
};